import AuthService from "@/services/auth.service";
import EventBus from "@/utils/EventBus";

export default {
    methods: {
        checkErrorDevice(router: any, data: any) {
            if (router?.currentRoute?.path !== '/login') {
                if(data.code?.startsWith('EA_') || data.code?.startsWith('EU_')){
                    const param = {
                        title: '',
                        status: "error",
                      };
                      param.title = data?.errors
                      ? data.errors.map(item => item.message).join(', ')
                      : data.message;
                      EventBus.$emit("on-show-notications", param);
                    setTimeout(() => {
                        AuthService.logout();
                        router.push("/login");
                    }, 3500);
                }
            }
        },
    },
};
